// material
import { experimentalStyled as styled } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Swal from "sweetalert2";
import TextField from "@material-ui/core/TextField";
import { Icon } from '@iconify/react';

import Grid from "@material-ui/core/Grid";
import { useTheme } from "@material-ui/core/styles";

import Stack from "@material-ui/core/Stack";
import Typography from "@material-ui/core/Typography";
import { useState, useEffect } from "react";
import SecureLS from "secure-ls";
import Page from "src/components/Page";
import LoadingButton from "@material-ui/lab/LoadingButton";
import { useSearchParams, useLocation } from "react-router-dom";

import axios from "axios";
import { config } from 'src/network/tokenHelper';
import FirebaseApp from "firebase/app";
import "firebase/auth";

import { getSessionToken } from "../../utils/sessionManager";
import { useNavigate } from "react-router-dom";

import "firebase/auth";

var ls = new SecureLS();

// ----------------------------------------------------------------------
const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up("md")]: {
    display: "flex",
  },
}));

// ----------------------------------------------------------------------

export default function Login() {


  const theme = useTheme();

  var [userCurrentState, setUserCurrentState] = useState("Email");
  var [isSubmitting, setSubmitting] = useState(false);
  var [EmailNumber, setEmailNumber] = useState(null);
  const [params, setSearchParams] = useSearchParams();
  var [otpNumber, setOtpNumber] = useState(null);
  var [askName, setAskName] = useState();
  var [name, setName] = useState("");
  const location = useLocation();
  var [customToken, setCustomToken] = useState(null);

  var [isVerified, setIsVerified] = useState(
    localStorage.getItem("userVerified")
      ? localStorage.getItem("userVerified")
      : false
  );

  var [isAuthenticated, setIsAuthenticated] = useState(
    localStorage.getItem("userAuthenticated")
      ? localStorage.getItem("userAuthenticated")
      : false
  );
  const navigate = useNavigate();

  const ContentStyle = styled("div")(({ theme }) => ({
    width: "100%",
    maxWidth: 500,
    backgroundColor: `${theme.palette.background.card}`,
    borderRadius: "25px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    margin: theme.spacing(2, 0, 2, 2),
    padding: theme.spacing(5, 5),
  }));

  const SectionStyle = styled("div")(({ theme }) => ({
    maxWidth: 600,
    margin: "auto",
    display: "flex",
    minHeight: "100vh",
    flexDirection: "column",
    justifyContent: "center",
    padding: theme.spacing(5, 5),
  }));

  if (
    isAuthenticated !== null &&
    isAuthenticated.toString() == "true" &&
    isVerified !== null &&
    isVerified.toString() == "true"
  ) {
    navigate("/dashboard/app");
  } else if (
    isAuthenticated !== null &&
    isAuthenticated.toString() == "true" &&
    (isVerified === null || isVerified.toString() == "false")
  ) {
    navigate("/auth/verify");
  }

  const uid = params.get("uid");

  useEffect(() => {
    if (uid) {
      axios
        .post(
          `${process.env.REACT_APP_BACKEND_URL}/user/getCustomToken`,
          { uid },
          config
        )
        .then((res) => {
          const token = res.data.customToken;
          signInWithCustomToken(token);
        });
    }
  }, [uid]);

  
  const submitEmailToMongo = async (event, EmailVal) => {
    setSubmitting((isSubmitting) => true);

    axios
      .post(
        `${process.env.REACT_APP_TATA_POWER_BACKEND_URL}/auth/getUserByEmail`,
        { email: EmailVal },
        config
      )
      .then((res) => {
        if (res.data.success) {
          const response = res.data;
          if (response?.user?.emailVerified && response?.user?.password) {
            setUserCurrentState("Password")
            setSubmitting((isSubmitting) => false);
          } else if(response?.user?.emailVerified){
            setUserCurrentState("SetPassword")
            setSubmitting((isSubmitting) => false);
          }
           else {
            setUserCurrentState("VerifyEmail")
            setSubmitting((isSubmitting) => false);
          }
        } else {
          setUserCurrentState("Email");
          setSubmitting((isSubmitting) => false);
          Swal.fire("Error", res.data.message, "error")
        }
      })
      .catch((err) => {
        setUserCurrentState("Email");
      });
  };

  const submitVerifyOTP = async (event, otpVal) => {

    if (event != null && event != undefined) event.preventDefault();

    setSubmitting((isSubmitting) => true);

    axios
      .post(
        `${process.env.REACT_APP_TATA_POWER_BACKEND_URL}/auth/emailVerification`,
        { email: EmailNumber,
          otp:otpVal
        },
        config
      )
      .then((res) => {
        if (res.data.success) {
          setUserCurrentState("SetPassword")
          setSubmitting((isSubmitting) => false);

        } else {
          Swal.fire("Error", res.data.message, "error")
          setSubmitting((isSubmitting) => false);

        }
      })
      .catch((err) => {
        setUserCurrentState("Email");
        setSubmitting((isSubmitting) => false);
      });
  };

  const submitSetPassword = async(event,password,confirmPassword) => {
    setSubmitting(true)
    
    if (password !== confirmPassword) {
      setSubmitting(false)
      return Swal.fire("Error", "Password and Confirm Password does not match", "error")
    }
      
    axios
      .post(
        `${process.env.REACT_APP_TATA_POWER_BACKEND_URL}/auth/setUserPassword`,
        { email: EmailNumber,
          password,
          confirmPassword
        },
        config
      )
      .then((res) => {
        if (res.data.success) {
          console.log("Login successful")
      signInWithCustomToken(res.data.customToken)

        } else {
          Swal.fire("Error", res.data.message, "error")
          setSubmitting(false)

        }
      })
      .catch((err) => {
        setUserCurrentState("SetPassword");
        setSubmitting(false)

      });
  }

  const submitPassword = async(event,password) => {
   setSubmitting(true)
    axios
      .post(
        `${process.env.REACT_APP_TATA_POWER_BACKEND_URL}/auth/loginWithEmail`,
        { email: EmailNumber,
          password,
          
        },
        config
      )
      .then((res) => {
        if (res.data.success) {
          console.log("Login successful")
        signInWithCustomToken(res.data.customToken)

        } else {
          Swal.fire("Error", res.data.message, "error")
          setSubmitting(false)

        }
      })
      .catch((err) => {
        setUserCurrentState("Password");
        setSubmitting(false)
      });
}
   

  async function signInWithCustomToken(customToken){
    var customTokenVal = customToken;
    try {
      await FirebaseApp.auth()
        .setPersistence(FirebaseApp.auth.Auth.Persistence.LOCAL)
        .then(
          await FirebaseApp.auth()
            .signInWithCustomToken(customToken)
            .then((res) => {

              localStorage.setItem("userAuthenticated", true);
              localStorage.setItem("userId", res.user.uid);
              localStorage.setItem("userEmail", res.user.email);
              localStorage.setItem("userName", res.user.displayName || res.user.email.split('@')[0]);
              getSessionToken();
              localStorage.setItem("userVerified", false);
              window.location.pathname = "/auth/verify"
              
            })
        )
        .catch((error) => {

          alert(error.message);
          setSubmitting((isSubmitting) => false);
          setUserCurrentState("Email");
        });
    } catch (error) {

      alert(error.message);
      setSubmitting((isSubmitting) => false);
      setUserCurrentState("Email");
    }
  };

  const LeftView = () => {
    return (
      <Grid item xs={12} sm={12} md={6} ls={6} xl={6}
        sx={{
          display: { xs: 'none', sm: 'none', md: 'flex', ls: 'flex', sx: 'flex' }, height: { xs: '0vh', sm: '0vh', md: '100vh', ls: '100vh', sx: '100vh' },
          flexDirection: "column", alignItems: "center", justifyContent: "center", background: "#0166AC"
        }}>
        <SectionStyle>
          <Typography variant="h2" sx={{ px: 5, color: "white" }}>
            Hi, Welcome!
          </Typography>
          <img
            src="/img_new/log_in_v3.svg"
            style={{ width: "100%", marginTop: "30px" }}
            alt="login"
          />
          <p style={{ marginTop: '30px', color: "white", textAlign: "center", fontSize: "120%" }}>
            www.tatapower.ems.ingroenergy.com
          </p>

        </SectionStyle>

      </Grid>
    )
  }

  const PasswordView = () => {
    var [passwordLocal, setPasswordLocal] = useState(null);
    var [showPassword, setShowPassword] = useState(false);

    return (
      <div>
        {/* <Icon icon="material-symbols:shield-lock" style={{ fontSize: '48px', color: theme.palette.primary.main, marginBottom: '5px' }} /> */}
        <Typography variant="h6" sx={{ mb: 2, color: `${theme.palette.text.disabled}` }}>
          Login using your email and password.
        </Typography>
        
        <Typography sx={{ mb: 2, fontSize: "14px", color: `${theme.palette.text.secondary}`, fontWeight: 'bold' }}>
          Logging in as: {EmailNumber}
        </Typography>
       
        <Stack spacing={1}>
          <div style={{ marginTop: "10px" }}>
            
            <Typography sx={{ fontSize: "16px", marginBottom: '8px', color: `${theme.palette.text.secondary}` }}>
              Enter your password
            </Typography>

            <TextField
              fullWidth
              autoComplete="password"
              size="medium"
              type={showPassword ? "text" : "password"}
              value={passwordLocal}
              InputProps={{
                startAdornment: (
                  <Icon icon="material-symbols:lock" style={{ fontSize: '20px', color: theme.palette.text.secondary, marginRight: '8px' }} />
                ),
                endAdornment: (
                  <Icon
                    icon={showPassword ? "material-symbols:visibility-off" : "material-symbols:visibility"}
                    style={{ 
                      fontSize: '20px', 
                      color: theme.palette.text.secondary, 
                      cursor: 'pointer',
                      marginRight: '8px'
                    }}
                    onClick={() => setShowPassword(!showPassword)}
                  />
                ),
                style: {
                  borderRadius: "10px",
                  fontSize: '20px', 
                  fontWeight: 'bold',
                  color: `${theme.palette.text.primary}`,
                  paddingLeft: "15px"
                },
              }}
              onChange={(event) => {
                setPasswordLocal(event.target.value);
              }}
              onKeyDown={(event) => {
                if (event.key === 'Enter' && passwordLocal && !isSubmitting) {
                  submitPassword(event, passwordLocal);
                }
              }}
            />
          </div>

        </Stack>
        {isSubmitting ? (
          <LoadingButton
            fullWidth
            size="medium"
            type="submit"
            variant="contained"
            loading={true}
            style={{ marginTop: "20px", borderRadius: "10px", boxShadow: "none" }}
          >
            Loading please wait
          </LoadingButton>
        ) : (
          <Button
            fullWidth
            size="medium"
            type="submit"
            variant="contained"
            style={{ marginTop: "20px", borderRadius: "10px", boxShadow: "none" }}
            onClick={(e) => submitPassword(e, passwordLocal)}
          >
            Submit
          </Button>
        )}
      </div>
    )
  }

  const submitEmailClicked = (event, EmailVal) => {
    setEmailNumber(EmailVal);
    submitEmailToMongo(event, EmailVal);
  }

  const submitOtpClicked = (event, OtpVal) => {
    setOtpNumber(OtpVal);
    submitVerifyOTP(event,OtpVal)
  }

  const EnterEmailView = () => {

    var [EmailNumberLocal, setEmailNumberLocal] = useState(null);

    return (
      <div>
        {/* <Icon icon="material-symbols:security" style={{ fontSize: '48px', color: theme.palette.primary.main, marginBottom: '10px' }} /> */}
        <Typography variant="h6" sx={{ mb: 2, color: `${theme.palette.text.disabled}` }}>
          Login using your email and password.
        </Typography>
        <Typography sx={{ mb: 1, color: `${theme.palette.text.secondary}`, fontSize: "16px" }}>
          Enter your email.
        </Typography>
        <Stack spacing={3}>
          <TextField
            fullWidth
            autoComplete="email"
            size="medium"
            type="text"
            value={EmailNumberLocal}
            disabled={isSubmitting}
            style={{
              borderRadius: "10px"
            }}
            InputProps={{
                startAdornment: (
                  <Icon icon="material-symbols:account-circle" style={{ fontSize: '20px', color: theme.palette.text.secondary, marginRight: '8px' }} />
                ),
                style: {
                  borderRadius: "10px",
                  fontSize: '20px', 
                  fontWeight: 'bold',
                  color: `${theme.palette.text.primary}`,
                  paddingLeft: "15px"
                },
              }}
            onChange={(event) => {
              setEmailNumberLocal(event.target.value);
            }}
            onKeyDown={(event) => {
              if (event.key === 'Enter' && EmailNumberLocal && !isSubmitting) {
                submitEmailClicked(event, EmailNumberLocal);
              }
            }}
          />
        </Stack>

        {isSubmitting ? (
          <LoadingButton
            fullWidth
            size="medium"
            type="submit"
            variant="contained"
            loading={true}
            style={{ marginTop: "20px", borderRadius: "10px", boxShadow: "none" }}
          >
            Loading please wait
          </LoadingButton>
        ) : (
          <Button
            fullWidth
            size="medium"
            type="submit"
            variant="contained"
            style={{ marginTop: "20px", borderRadius: "10px", boxShadow: "none" }}
            onClick={(e) => submitEmailClicked(e, EmailNumberLocal)}
          >
            Submit
          </Button>
        )}
      </div>
    )
  }

  const SetPasswordView = () => {
    var [passwordLocal, setPasswordLocal] = useState(null);
    var [confirmPasswordLocal, setConfirmPasswordLocal] = useState(null);
    var [showPassword, setShowPassword] = useState(false);
    var [showConfirmPassword, setShowConfirmPassword] = useState(false);

    return (
      <div>
        <Typography sx={{ mb: 1, color: `${theme.palette.text.secondary}`, fontSize: "16px" }}>
          Email verified please set your password.
        </Typography>
        <Stack spacing={3}>
          <TextField
            fullWidth
            value={passwordLocal}
            label='Password'
            type={showPassword ? "text" : "password"}
            size="medium"
            InputProps={{
              endAdornment: (
                <Icon
                  icon={showPassword ? "material-symbols:visibility-off" : "material-symbols:visibility"}
                  style={{ 
                    fontSize: '20px', 
                    color: theme.palette.text.secondary, 
                    cursor: 'pointer',
                    marginRight: '8px'
                  }}
                  onClick={() => setShowPassword(!showPassword)}
                />
              ),
              style: {
                borderRadius: "10px",
                fontSize: '16px'
              }
            }}
            sx={{ mb: 1, mt: 0.5 }}
            onChange={(e) => { setPasswordLocal(e.target.value) }}
            onKeyDown={(event) => {
              if (event.key === 'Enter' && passwordLocal) {
                event.preventDefault();
                document.querySelector('input[type="password"]:not(:first-of-type)').focus();
              }
            }}

          />
          <TextField
            fullWidth
            label='Confirm Password'
            value={confirmPasswordLocal}
            type={showConfirmPassword ? "text" : "password"}
            size="medium"
            InputProps={{
              endAdornment: (
                <Icon
                  icon={showConfirmPassword ? "material-symbols:visibility-off" : "material-symbols:visibility"}
                  style={{ 
                    fontSize: '20px', 
                    color: theme.palette.text.secondary, 
                    cursor: 'pointer',
                    marginRight: '8px'
                  }}
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                />
              ),
              style: {
                borderRadius: "10px",
                fontSize: '16px'
              }
            }}
            sx={{ mb: 1, mt: 0.5 }}
            onChange={(e) => { setConfirmPasswordLocal(e.target.value) }}
            onKeyDown={(event) => {
              if (event.key === 'Enter' && passwordLocal && confirmPasswordLocal && !isSubmitting) {
                submitSetPassword(event, passwordLocal, confirmPasswordLocal);
              }
            }}
          />


          <div style={{ marginTop: "10px", marginBottom: "20px" }}>
            <Typography sx={{ fontSize: "14px", color: `${theme.palette.text.disabled}`, ml: 0.5 }}>Password must be at least 6 characters long</Typography>
          </div>
        </Stack>

        {isSubmitting ? (
          <LoadingButton
            fullWidth
            size="medium"
            type="submit"
            variant="contained"
            loading={true}
            style={{ marginTop: "20px", borderRadius: "10px", boxShadow: "none" }}
          >
            Loading please wait
          </LoadingButton>
        ) : (
          <Button
            fullWidth
            size="medium"
            type="submit"
            variant="contained"
            style={{ marginTop: "20px", borderRadius: "10px", boxShadow: "none" }}
            onClick={(e) => submitSetPassword(e, passwordLocal,confirmPasswordLocal)}
          >
            Submit
          </Button>
        )}
      </div>
    )
  }

  const VerifyEmailView = () => {
    var [OTPLocal, setOTPLocal] = useState(null);

    return (
      <div>
        <Typography sx={{ mb: 1, color: `${theme.palette.text.secondary}`, fontSize: "16px" }}>
          An OTP has been sent to your email. Please verify the OTP
        </Typography>
        <Stack spacing={3}>
          <TextField
            fullWidth
            autoComplete="email"
            size="medium"
            type="text"
            value={OTPLocal}
            disabled={isSubmitting}
            label="Enter OTP"
            style={{
              borderRadius: "10px"
            }}
            InputProps={{
              startAdornment: (
                <Icon icon="material-symbols:pin" style={{ fontSize: '20px', color: theme.palette.text.secondary, marginRight: '8px' }} />
              ),
              style: {
                borderRadius: "10px",
                paddingLeft: "15px",
                paddingRight: "15px",
                fontSize: '16px', color: `${theme.palette.text.primary}`
              },
            }}
            onChange={(event) => {
              setOTPLocal(event.target.value);
            }}
            onKeyDown={(event) => {
              if (event.key === 'Enter' && OTPLocal && !isSubmitting) {
                submitOtpClicked(event, OTPLocal);
              }
            }}
          />
        </Stack>

        {isSubmitting ? (
          <LoadingButton
            fullWidth
            size="medium"
            type="submit"
            variant="contained"
            loading={true}
            style={{ marginTop: "20px", borderRadius: "10px", boxShadow: "none" }}
          >
            Loading please wait
          </LoadingButton>
        ) : (
          <Button
            fullWidth
            size="medium"
            type="submit"
            variant="contained"
            style={{ marginTop: "20px", borderRadius: "10px", boxShadow: "none" }}
            onClick={(e) => submitOtpClicked(e, OTPLocal)}
          >
            Submit
          </Button>
        )}
      </div>
    )
  }

  const RightView = () => {
    return (
      <Grid item xs={12} sm={12} md={6} ls={6} xl={6} style={{ minHeight: "100vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
        <ContentStyle>
          
          <Stack direction="row" alignItems="center" sx={{ mb: 1 }}>
            <div style={{ width: "100%", display: "flex", flexDirection: "row", alignItems: "center", gap: "10px" }}>
              <div style={{ display: "flex", flexDirection: "row", width: "100%", gap: "10px", alignItems: 'center' }}>
                <img src="/logo/ingro/ingro_ems_logo.png" style={{ maxWidth: "400px", maxHeight: "40px" }} />
              </div>
            </div>
          </Stack>

          {
            userCurrentState == "Password" ? (<PasswordView />) :
              (userCurrentState == "SetPassword" ? <SetPasswordView /> :
                (userCurrentState == "VerifyEmail" ? <VerifyEmailView /> :
                  <EnterEmailView />))
          }        </ContentStyle>
      </Grid>
    )
  }

  return (
    <Page style={{ width: "100%" }}>
      <div style={{ width: "100%" }}>
        <Grid container>
          <LeftView />
          <RightView />
        </Grid>
      </div>
    </Page>
  );
}